export const matchYoutubeID = (url = '') => {
  if (!url) return url;
  // Ex. https://www.youtube.com/watch?app=desktop&v=JBdqo7-3XMA
  const queryMatch = url.match(/[?&]v=([A-Za-z0-9_-]+)/)?.[1];
  const embedMatch = url.match(/youtube\.com\/embed\/([A-Za-z0-9_-]+)/)?.[1];
  const shortMatch = url.match(/youtu\.be\/([A-Za-z0-9_-]+)/)?.[1];
  if (queryMatch) return queryMatch;
  if (embedMatch) return embedMatch;
  return shortMatch;
};
